import { z } from 'zod';

import i18n from '@/lib/i18n';

export const futuresClientCategorisationProfessionalAgreementSchema = z
  .object({
    date: z.iso.date(),
    name: z.string().min(1, { error: i18n.t('FuturesAppropriatenessClientCategorisation.professionalAgreement.errors.name') }),
    signature: z.string().min(1, { error: i18n.t('FuturesAppropriatenessClientCategorisation.professionalAgreement.errors.signature') }),
  })
  .superRefine((data, ctx) => {
    if (data.name.toLowerCase() !== data.signature.toLowerCase()) {
      ctx.addIssue({
        code: 'custom',
        message: i18n.t('FuturesAppropriatenessClientCategorisation.professionalAgreement.errors.nameSignatureMismatch'),
        path: ['signature'],
      });
    }
  });

export type FuturesClientCategorisationProfessionalAgreement = z.infer<typeof futuresClientCategorisationProfessionalAgreementSchema>;
